import React from "react";
import PropTypes from "prop-types";
import { Select } from "../../../components/Select";
import { RadioButton } from "../../../components/RadioButton";

/**
 * @param {Collections.propTypes} props
 */
export const Collections = (props) => {
	// We have to convert the collection objects to just the string array.
	const availableCollections = (props.boardCollections || []).map((item) =>
		item.collectionName.replace("#", "")
	);

	/**
	 * Add selected collection to the form data.
	 */
	const addToCollection = (collection) => {
		props.onChange({
			...props.value,
			collections: [...props.value.collections, collection],
		});
	};

	/**
	 * Remove selected collection from the form data.
	 */
	const removeFromCollections = (collection) => {
		props.onChange({
			...props.value,
			collections: props.value.collections.filter(
				(item) => item !== collection
			),
		});
	};

	// No need to render collection selector if the view mode is calendar.
	if (props.value.view === "CV") return null;

	return (
		<div className="mb-8">
			<div className="font-bold mb-1">Collections</div>
			<div className="text-sm leading-5 mb-3">
				Collections allow you to filter the content on your HootBoard.
				Your website visitors will only see hoots based on the
				collection logic below.
			</div>
			<Select
				color="plugin-3"
				value={0}
				onChange={addToCollection}
				options={[
					{
						label: "Select Collections",
						hidden: true,
						value: 0,
					},
					...availableCollections
						.filter(
							(item) => !props.value.collections.includes(item)
						)
						.map((item) => ({
							value: item,
							label: "#" + item,
						})),
				]}
			/>
			<div className="mt-2 flex gap-2 flex-wrap">
				{props.value.collections.map((item, index) => {
					return (
						<div
							key={index}
							className="border-2 border-solid border-plugin-3 flex px-3 py-1 rounded-md text-plugin-3 text-sm"
						>
							<span>{item}</span>
							<span
								className="cursor-pointer ml-2 font-bold"
								onClick={() => {
									removeFromCollections(item);
								}}
							>
								x
							</span>
						</div>
					);
				})}
			</div>
			<div className="mt-4">
				<RadioButton
					isChecked={props.value.collectionsUnion}
					onCheck={() =>
						props.onChange({
							...props.value,
							collectionsUnion: true,
						})
					}
					label="Show hoots posted with any of the above collections"
					color="plugin-3"
				/>
				<div className="mb-2"></div>
				<RadioButton
					isChecked={!props.value.collectionsUnion}
					onCheck={() =>
						props.onChange({
							...props.value,
							collectionsUnion: false,
						})
					}
					label="Show hoots posted with all of the above collections"
					color="plugin-3"
				/>
			</div>
		</div>
	);
};

Collections.propTypes = {
	value: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
	boardCollections: PropTypes.array,
};
